import React from 'react';
import { motion } from 'framer-motion';
import { infoSources, painPoints, selfQuestions } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Bu durum size tanıdık geliyor mu" className="bg-obsidian text-white" data-id="element-163" data-mp="2lp55ksdk54u7">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "20px"
    }} data-id="element-164" data-mp="26wbmkwz2u6ks">
        <div className="max-w-3xl" data-id="element-165" data-mp="1xxrd8mfep998">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-none sm:text-6xl" data-id="element-166" data-mp="1xwol6b6cl0rq">
            Bu durum size tanıdık geliyor mu?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-white/75" data-id="element-167" data-mp="1nzjzsdkbt9bz">
            Uzun mesafe triatlonuna hazırlanıyorsunuz. Ancak hazırlığınızı organize etmeye
            çalıştığınızda, birbirinden farklı bilgiler arasında kaybolduğunuzu hissediyorsunuz.
          </p>
        </div>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-14" data-id="element-168" data-mp="3ibrz033okcdk">
          <div data-id="element-169" data-mp="3nbwh1xk8lf5w">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/45" data-id="element-170" data-mp="3nabmw91u3y8k">Elinizde şunlar olabilir</p>
            <ul className="mt-4 flex flex-wrap gap-2" data-id="element-171" data-mp="1u1lkuz2qd94m">
              {infoSources.map(s => <li key={s} className="rounded-lg border border-white/15 px-3 py-1.5 text-sm text-white/80" data-id="element-172" data-mp="1tzhiwmoe6k6z">
                  {s}
                </li>)}
            </ul>
            <p className="mt-5 text-lg font-semibold text-ember" data-id="element-173" data-mp="23sokrxjxbi2b">Ancak bunların hepsi birbiriyle bağlantılı olmayabilir.</p>
          </div>
          <div data-id="element-174" data-mp="1g3njqvdf7972">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/45" data-id="element-175" data-mp="1b2zizhze3dzn">Kendinize sürekli şu soruları soruyor musunuz?</p>
            <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-176" data-mp="1p3absqk9f2ng">
              {selfQuestions.map(q => <li key={q} className="flex gap-2.5 text-[15px] leading-snug text-white/80" data-id="element-177" data-mp="1k2cyara72wsa">
                  <span className="font-bold text-ember" aria-hidden="true" data-id="element-178" data-mp="30gmkbeqys9fy">?</span>
                  {q}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-14 border-y border-white/10 py-10 text-center" data-id="element-179" data-mp="1t5f0pw9vz526">
          <p className="text-lg text-white/60" data-id="element-180" data-mp="1t7hpkczays5b">Sorun her zaman motivasyon eksikliği değildir.</p>
          <p className="mx-auto mt-3 max-w-3xl font-display text-4xl font-extrabold uppercase leading-none sm:text-6xl" data-id="element-181" data-mp="1y62rqhy47lwe">
            Bazen asıl sorun, bütün hazırlığı bir arada tutan bir <span className="text-electric" data-id="element-182" data-mp="274egsfjc2bmq">sistemin</span> eksikliğidir.
          </p>
        </div>

        <ol className="divide-y divide-white/10" data-id="element-183" data-mp="1ag8cxuu8jn9i">
          {painPoints.map(({
          icon: Icon,
          title,
          body,
          list,
          resolve
        }) => <motion.li key={title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-4 py-9 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-12" data-id="element-184" data-mp="1jfloct1x6lwv">
              <div className="flex items-start gap-4" data-id="element-185" data-mp="vo6hqo341ift">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-ember/30 bg-ember/10 text-ember" data-id="element-186" data-mp="o6rvmftclny0">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-187" data-mp="j7yi4ne29wxu" />
                </span>
                <h3 className="pt-1 font-display text-2xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-188" data-mp="e6rduyb4nfvx">
                  {title}
                </h3>
              </div>
              <div className="space-y-3 text-[15px] leading-relaxed text-white/70 lg:pt-1.5" data-id="element-189" data-mp="57nojclda48z">
                {body.map(b => <p key={b} data-id="element-190" data-mp="fmfdzjhwtn6">{b}</p>)}
                {list && <ul className="space-y-1.5" data-id="element-191" data-mp="euk6ptt8xxf">
                    {list.map(item => <li key={item} className="flex gap-2.5" data-id="element-192" data-mp="3rni7hbbm2v7m">
                        <span className="text-ember" aria-hidden="true" data-id="element-193" data-mp="3modxiigv4tg8">—</span>
                        {item}
                      </li>)}
                  </ul>}
                {resolve && <p className="font-semibold text-white" data-id="element-194" data-mp="3io3i6f76kqop">{resolve}</p>}
              </div>
            </motion.li>)}
        </ol>

        <div className="mt-8 rounded-2xl bg-electric px-6 py-9 text-center" data-id="element-195" data-mp="1hjj7nd1gedyx">
          <p className="mx-auto max-w-2xl font-display text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-196" data-mp="1llmvl15b7b13">
            Bu sorulardan bazılarına evet diyorsanız, SIGMA SMART™ hazırlığınızı daha sistematik hale getirmenize yardımcı olacak bir çözüm sunuyor.
          </p>
        </div>
      </div>
    </section>;
}